import React, { useMemo, useContext } from "react";

import { AssigneeSelector } from "fe-shared/src/components";
import UserContext from "contexts/userContext";

import useAssignTransfers from "hooks/useAssignTransfers";

import { Transfer, TransferStatus } from "fe-shared-transactions/src/types";

const assignStatuses: TransferStatus[] = [
  TransferStatus.Submitted,
  TransferStatus.InReview,
];

interface Props {
  canAssign?: boolean;
  transfer: Transfer;
  assigneeName?: string;
  assigneeId?: string | number;
}

const AssigneeTransfersSelect = ({
  canAssign = true,
  transfer,
  assigneeId,
  assigneeName,
}: Props) => {
  const { transferId, statusCode } = transfer;
  const { userId: currentUserId } = useContext(UserContext)!;
  const [changeAssignee] = useAssignTransfers();

  const isAssignable = useMemo(
    () => canAssign && assignStatuses.includes(statusCode),
    [statusCode, canAssign]
  );
  const isAssigned = !!assigneeId;

  const onChange = (newAssigneeId: string | number | null) => {
    changeAssignee({
      ids: [transferId],
      assigneeId: newAssigneeId,
    });
  };

  return (
    <AssigneeSelector
      entityId={transferId.toString()}
      isAssignable={isAssignable}
      isUnAssignable={false}
      loadOnlyActive={true}
      isAssigned={isAssigned}
      currentUserId={currentUserId}
      assigneeId={assigneeId}
      assigneeName={assigneeName}
      onChange={onChange}
    />
  );
};

export default AssigneeTransfersSelect;
